import { ReactElement } from 'react';
import Grid from '@material-ui/core/Grid';

import { isoToFormat } from '~/utils/date';
import styles from './Header.module.scss';
import { Timezone } from '~/types';

interface IProps {
  fullName: string;
  subjectId: string;
  dateOfBirth: string;
}

const Header = ({ fullName, subjectId, dateOfBirth }: IProps): ReactElement => (
  <Grid container spacing={1}>
    <Grid item xs={4}>
      <div className={styles.tab}>{`Patient: ${fullName}`}</div>
    </Grid>
    <Grid item xs={4} className={styles.col}>
      <div className={styles.tab}>{`Patient ID: ${subjectId}`}</div>
    </Grid>
    <Grid item xs={4} className={styles.col}>
      <div className={styles.tab}>{`DOB: ${
        dateOfBirth ? isoToFormat(dateOfBirth, 'dd MMM y', Timezone.GMT, false) : '-'
      }`}</div>
    </Grid>
  </Grid>
);

export default Header;
